import { useEffect, useState } from "react";
import { z } from "zod";

const MaintenanceModeSchema = z.object({
  title: z.string(),
  message: z.string(),
  type: z.literal("write-ops"),
});

type MaintenanceMode = z.infer<typeof MaintenanceModeSchema> | null;

export function useMaintenanceMode(): MaintenanceMode {
  const [maintenanceMode, setMaintenanceMode] = useState<MaintenanceMode>(null);

  useEffect(() => {
    const maintenanceModePayload =
      process.env.NEXT_PUBLIC_CONSOLE_MAINTENANCE_MODE;

    if (maintenanceModePayload) {
      try {
        const parsedPayload = JSON.parse(maintenanceModePayload);
        const validatedPayload = MaintenanceModeSchema.parse(parsedPayload);
        setMaintenanceMode(validatedPayload);
      } catch (error) {
        // biome-ignore lint/suspicious/noConsole: <explanation>
        console.error("Error parsing maintenance mode payload:", error);
        setMaintenanceMode(null);
      }
    } else {
      setMaintenanceMode(null);
    }
  }, []);

  return maintenanceMode;
}
